import { Link } from '@afterpaytouch/core'
import clsx from 'clsx'
import React, { FunctionComponent, ReactNode } from 'react'
import { Route } from '../../config/router'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { useAppRouter } from '../../state'

import styles from './style.module.css'

export interface AppLinkProps {
  route: Route
  noMargin?: boolean
  center?: boolean
  underline?: boolean
  inline?: boolean
  trackEventName?: string
  disabled?: boolean
  children?: ReactNode
}

export const AppLink: FunctionComponent<AppLinkProps> = ({
  route,
  noMargin = false,
  center = false,
  underline = false,
  inline = false,
  disabled = false,
  trackEventName = '',
  children,
}) => {
  const router = useAppRouter()
  const { logEvent } = useMonitoringWithEnduringEventProperties()

  const className = clsx(styles.wrapper, noMargin && styles.noMargin, center && styles.center, inline && styles.inline)

  const testNameSpace = route.replace(/\//, '').replace(/\//g, '-')

  return (
    <div className={className}>
      <Link
        disabled={disabled}
        kind={underline ? 'Underline' : 'Emphasis'}
        onClick={() => {
          if (trackEventName !== '' || trackEventName !== undefined) {
            logEvent(trackEventName)
          }
          router.push(route)
        }}
        testNameSpace={testNameSpace}
        data-dd-action-name={`Back To ${testNameSpace} Link`}
      >
        {children}
      </Link>
    </div>
  )
}
